import React from 'react';
import { ImageBackground, ImageSourcePropType, StyleSheet, ViewStyle } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { colors } from '../theme';

interface BrandWireframeProps {
  style?: ViewStyle;
  /** Real product hero image to show full-bleed (cover) over the gradient base. Omit for the
   * plain gradient alone. */
  source?: ImageSourcePropType;
}

/** Brand background used behind the Welcome screen and (on desktop web) DualPaneLayout's left
 * pane. A brand-gold gradient base with an optional real product hero photo/illustration laid
 * over it, full-bleed. No shapes, no animation — replaces an earlier dense, constantly-pulsing
 * SVG wireframe and a later hand-drawn SVG attempt, both of which read as placeholder art
 * rather than real design. */
export const BrandWireframe: React.FC<BrandWireframeProps> = ({ style, source }) => {
  if (source) {
    return (
      <ImageBackground source={source} resizeMode="cover" style={style}>
        <LinearGradient
          colors={[colors.secondary as string, 'transparent']}
          start={{ x: 0, y: 0 }}
          end={{ x: 0.6, y: 0.6 }}
          style={StyleSheet.absoluteFill}
          pointerEvents="none"
        />
      </ImageBackground>
    );
  }
  return (
    <LinearGradient
      colors={[colors.secondary as string, colors.primary as string, colors.accent as string]}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      style={style}
      pointerEvents="none"
    />
  );
};
